export const setAbandonedCartId = (abandonedCartId) => {
  if (import.meta.env.VITE_NODE_ENV === "production") {
    try {
      FS.setUserVars({
        abandonedCartId,
      });
    } catch (e) {}
  }
};
